import {
  LLD_WAITING_USERS_DOWNLOADED,
  LLD_WAITING_USERS_FAILED,
  LLD_WAITING_USERS_PENDING,
  LLD_WAITING_USERS_REMOVED,
  LLD_WAITING_USERS_SENDING,
} from './types';
import LongLocationWaitingUsersApiService
  from '../../services/api/LongLocationWaitingUsersApiService';
import { handleError } from '../infos/actions';

export const lldWaitingUsersPendingAction = () => ({
  type: LLD_WAITING_USERS_PENDING,
});

export const lldWaitingUsersFailedAction = (error) => ({
  type: LLD_WAITING_USERS_FAILED,
  payload: error,
});

export const lldWaitingUsersDownloadedAction = (content) => ({
  type: LLD_WAITING_USERS_DOWNLOADED,
  payload: content,
});

export const lldWaitingUsersRemovedAction = (content) => ({
  type: LLD_WAITING_USERS_REMOVED,
  payload: content,
});

export const lldWaitingUsersSendingAction = () => ({
  type: LLD_WAITING_USERS_SENDING,
});

export function getLongLocationWaitingUsers(token) {
  return (dispatch) => {
    dispatch(lldWaitingUsersPendingAction());
    return LongLocationWaitingUsersApiService
      .getLongLocationWaitingUsers(token)
      .then(data => {
        dispatch(lldWaitingUsersDownloadedAction(data));
        return data;
      })
      .catch(error => {
        dispatch(lldWaitingUsersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function deleteLongLocationWaitingUser(token, lldWaitingId) {
  return (dispatch) => {
    dispatch(lldWaitingUsersSendingAction());
    return LongLocationWaitingUsersApiService
      .deleteLongLocationWaitingUsers(token, lldWaitingId)
      .then(() => {
        dispatch(lldWaitingUsersRemovedAction(lldWaitingId));
        return null;
      })
      .catch((error) => {
        dispatch(lldWaitingUsersFailedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/lldWaitingUsers/actions.js